module.exports = __webpack_public_path__ + "bf083e58470cb99e038396a86c7b8d65.png";